import { useState, type FormEvent } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";

const navItems = [
  { label: "首页", to: "/" },
  { label: "动漫资讯", to: "/news" },
  { label: "作品推荐", to: "/works" },
  { label: "剧情解析", to: "/analysis" },
  { label: "动漫文化", to: "/culture" },
  { label: "关于我们", to: "/about" },
];

export default function SiteHeader() {
  const navigate = useNavigate();
  const [keyword, setKeyword] = useState("");
  const [mobileOpen, setMobileOpen] = useState(false);

  const submitSearch = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const value = keyword.trim();
    setMobileOpen(false);
    if (value) {
      navigate(`/search?q=${encodeURIComponent(value)}`);
      setKeyword("");
    } else {
      navigate("/search");
    }
  };

  return (
    <header className="sticky top-0 z-50 border-b border-background-200 bg-background-50/95 backdrop-blur">
      <div className="flex h-16 w-full items-center gap-4 px-4 md:px-8 lg:px-12">
        <Link to="/" className="flex cursor-pointer items-center gap-2" aria-label="星空动漫首页">
          <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500">
            <i className="ri-planet-fill text-xl text-accent-300" />
          </span>
          <span className="flex flex-col leading-none">
            <span className="font-heading text-lg font-bold tracking-tight text-foreground-950">
              星空动漫
            </span>
            <span className="mt-0.5 text-[10px] font-medium tracking-[0.2em] text-foreground-400">
              STAR ANIME
            </span>
          </span>
        </Link>

        <nav className="ml-4 hidden items-center gap-1 md:flex">
          {navItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.to === "/"}
              className={({ isActive }) =>
                `cursor-pointer whitespace-nowrap rounded-md px-3 py-2 text-sm font-medium transition-colors ${
                  isActive
                    ? "bg-primary-50 text-primary-700"
                    : "text-foreground-700 hover:bg-background-100 hover:text-primary-600"
                }`
              }
            >
              {item.label}
            </NavLink>
          ))}
        </nav>

        <div className="ml-auto flex items-center gap-2">
          <form onSubmit={submitSearch} className="hidden lg:block">
            <label className="flex items-center gap-2 rounded-full border border-background-200 bg-background-100 px-3 py-1.5 transition-colors focus-within:border-primary-300">
              <i className="ri-search-line text-base text-foreground-400" />
              <input
                type="search"
                value={keyword}
                onChange={(event) => setKeyword(event.target.value)}
                placeholder="搜索资讯 / 作品 / 解析"
                className="w-48 bg-transparent text-sm text-foreground-800 placeholder:text-foreground-400 focus:outline-none"
                aria-label="站内搜索"
              />
            </label>
          </form>

          <Link
            to="/search"
            className="flex h-9 w-9 cursor-pointer items-center justify-center rounded-md border border-background-200 text-foreground-600 transition-colors hover:border-primary-300 hover:text-primary-600 lg:hidden"
            aria-label="搜索"
          >
            <i className="ri-search-line text-lg" />
          </Link>

          <button
            type="button"
            onClick={() => setMobileOpen((prev) => !prev)}
            className="flex h-9 w-9 cursor-pointer items-center justify-center rounded-md border border-background-200 text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600 md:hidden"
            aria-label="打开菜单"
            aria-expanded={mobileOpen}
          >
            <i className={`${mobileOpen ? "ri-close-line" : "ri-menu-line"} text-xl`} />
          </button>
        </div>
      </div>

      {mobileOpen ? (
        <div className="border-t border-background-200 bg-background-50 px-4 pb-5 pt-4 md:hidden">
          <form onSubmit={submitSearch} className="mb-4">
            <label className="flex items-center gap-2 rounded-md border border-background-200 bg-background-100 px-3 py-2">
              <i className="ri-search-line text-base text-foreground-400" />
              <input
                type="search"
                value={keyword}
                onChange={(event) => setKeyword(event.target.value)}
                placeholder="搜索资讯 / 作品 / 解析"
                className="w-full bg-transparent text-sm text-foreground-800 placeholder:text-foreground-400 focus:outline-none"
                aria-label="站内搜索"
              />
            </label>
          </form>
          <nav className="flex flex-col gap-1">
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.to === "/"}
                onClick={() => setMobileOpen(false)}
                className={({ isActive }) =>
                  `cursor-pointer rounded-md px-3 py-3 text-base font-medium transition-colors ${
                    isActive
                      ? "bg-primary-50 text-primary-700"
                      : "text-foreground-700 hover:bg-background-100"
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
          </nav>
        </div>
      ) : null}
    </header>
  );
}